import React from 'react';

const KeyboardShortcuts = () => {
  const shortcuts = [
    {
      category: 'Navigation',
      items: [
        { keys: ['Backspace'], description: 'Go back to previous page' },
        { keys: ['Alt', '←'], description: 'Browser back (alternative)' },
        { keys: ['Alt', '→'], description: 'Browser forward' },
      ]
    },
    {
      category: 'Filtering & Search',
      items: [
        { keys: ['Esc'], description: 'Close filter dropdown / Cancel current action' },
        { keys: ['Ctrl', 'F'], description: 'Browser find on page' },
      ]
    },
    {
      category: 'Editing Cells',
      items: [
        { keys: ['Click'], description: 'Start editing a cell' },
        { keys: ['Enter'], description: 'Save cell and exit edit mode' },
        { keys: ['Esc'], description: 'Cancel edit and restore original value' },
        { keys: ['Tab'], description: 'Move to next cell (in some tables)' },
      ]
    },
    {
      category: 'Selection',
      items: [
        { keys: ['Click checkbox'], description: 'Select/deselect a single row' },
        { keys: ['Header checkbox'], description: 'Select/deselect all visible rows' },
        { keys: ['Ctrl', 'A'], description: 'Select all text in input field' },
      ]
    },
    {
      category: 'General',
      items: [
        { keys: ['Ctrl', 'S'], description: 'Some forms auto-save, but use this for manual save' },
        { keys: ['F5'], description: 'Refresh the page' },
        { keys: ['Ctrl', 'Shift', 'R'], description: 'Hard refresh (clear cache)' },
      ]
    }
  ];

  return (
    <div style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ margin: 0, color: '#333', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          ⌨️ Keyboard Shortcuts
        </h2>
        <p style={{ color: '#666', marginTop: '0.5rem' }}>
          Use these keyboard shortcuts to navigate faster and work more efficiently in LGL Portal.
        </p>
      </div>

      {shortcuts.map((section, idx) => (
        <div key={idx} style={{ marginBottom: '2rem' }}>
          <h3 style={{ 
            color: '#495057', 
            borderBottom: '2px solid #dee2e6', 
            paddingBottom: '0.5rem',
            marginBottom: '1rem'
          }}>
            {section.category}
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {section.items.map((item, itemIdx) => (
              <div 
                key={itemIdx} 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  padding: '0.75rem 1rem',
                  backgroundColor: itemIdx % 2 === 0 ? '#f8f9fa' : 'white',
                  borderRadius: '4px',
                  border: '1px solid #eee'
                }}
              >
                <div style={{ display: 'flex', gap: '0.25rem', minWidth: '200px' }}>
                  {item.keys.map((key, keyIdx) => (
                    <React.Fragment key={keyIdx}>
                      <kbd style={{
                        padding: '4px 8px',
                        backgroundColor: '#343a40',
                        color: 'white',
                        borderRadius: '4px',
                        fontSize: '0.85rem',
                        fontFamily: 'monospace',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                      }}>
                        {key}
                      </kbd>
                      {keyIdx < item.keys.length - 1 && (
                        <span style={{ color: '#666', margin: '0 2px' }}>+</span>
                      )}
                    </React.Fragment>
                  ))}
                </div>
                <span style={{ color: '#333' }}>{item.description}</span>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div style={{ 
        backgroundColor: '#e7f3ff', 
        padding: '1rem', 
        borderRadius: '8px', 
        marginTop: '2rem',
        border: '1px solid #b3d7ff'
      }}>
        <strong>💡 Pro Tip:</strong> Most shortcuts work across all pages in LGL Portal. 
        The <kbd style={{ padding: '2px 6px', backgroundColor: '#343a40', color: 'white', borderRadius: '3px', fontSize: '0.8rem' }}>Backspace</kbd> shortcut 
        only works when you're not typing in a text field.
      </div>
    </div>
  );
};

export default KeyboardShortcuts;
